<template>
  <div>
    <el-page-header @back="goBack" :content="titleText + '-销售计划'" />
    <zx-table
      :tableData="tableData"
      :option="table"
      :page="page"
      @handleSelectionChange="handleSelectionChange"
      @delBtn="delBtn"
      @refresh-change="getlist"
      @refreshBtn="refreshBtn"
    ></zx-table>
    <ele-form-dialog
      v-model="formData"
      :formDesc="formDesc"
      :request-fn="handleSubmit"
      :rules="rules"
      labelPosition="left"
      :form-attrs="{ size: 'small' }"
      :dialogAttrs="{
        center: false,
        'destroy-on-close': true,
        'custom-class': 'formD'
      }"
      v-dialogdrag
      :visible.sync="dialogFormVisible"
      @request-success="handleSuccess"
      :title="table.title"
    />
  </div>
</template>
<script>
import * as plan from "@/api/product/plan.js";
import * as ticket from "@/api/product/ticket.js";
import * as scenic from "@/api/product/scenic.js";
import xzTable from "@/components/xz-table.vue";
export default {
  components: {
    "zx-table": xzTable
  },
  data() {
    return {
      submitType: 1,
      rules: {},
      formDesc: {
        theater_name: {
          required: true,
          type: "input",
          label: "剧院名称",
          layout: 24
        },
        show_name: {
          required: true,
          type: "input",
          label: "节目名称",
          layout: 12
        },
        show_code: {
          required: true,
          type: "input",
          label: "节目编码",
          layout: 12
        },
        session_name: {
          required: true,
          type: "input",
          label: "场次名称",
          layout: 12
        },
        number: {
          required: true,
          label: "数量",
          type: "number",
          layout: 12,
          attrs: {
            min: 0,
            controls: false
          }
        },
        plan_time: {
          required: true,
          type: "date",
          label: "游玩时间",
          attrs: {
            valueFormat: "yyyy-MM-dd",
            pickerOptions: {
              disabledDate(time) {
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24);
                return time.getTime() <= start;
              }
            }
          }
        },
        play_date: {
          required: true,
          type: "time",
          label: "演出时间",
          attrs: {
            arrowControl: true,
            pickerOptions: {
              selectableRange: "18:30:00 - 24:30:00",
              start: "00:00",
              step: "00:10",
              end: "24:00"
            }
            // valueFormat: "hh:mm",
            // minTime: new Date(),
            // pickerOptions: {
            //   //   disabledDate(time) {
            //   //     const start = new Date();
            //   //     // start.setTime(start.getTime() - 3600 * 1000 * 24);
            //   //     return time.getTime() <= start;
            //   //   }
            // }
          }
        },
        show_model_code: {
          required: true,
          type: "input",
          label: "模板编码"
        },

        // status: 0,
        status: {
          required: true,
          type: "radio",
          label: "状态",
          layout: 12,
          default: 0,
          options: [
            {
              text: "可用",
              value: 0
            },
            {
              text: "已过期",
              value: 1
            }
          ]
        }
      },
      formData: {},
      dialogFormVisible: false,
      page: {
        total: 1,
        pagerCount: 1,
        currentPage: 1,
        pageSize: 25,
        pageSizes: [15, 25, 30, 40, 50, 100],
        // sizes, prev, pager, next, jumper, ->, total, slot
        // "layout":"prev, pager, next",
        layout: "total, sizes, prev, pager, next, jumper",
        background: true
      },
      table: {
        title: "销售计划",
        // 表格底部按钮
        btnBottom: false,
        // 操作按钮列定位 默认:false;
        fixed: false,
        // 子表格 默认: ; 数据格式:String;<对应子行字段名称>
        children: "children",
        // 多选 默认:false;
        // selection: false,
        // 单选高亮
        current: true,
        //搜索框 默认:false;
        searchBtn: false,
        // 表格高度 默认:100%; 数据格式:Number;
        // height:500,
        // 数边框 默认:false;
        border: false,
        //索引 默认:true;
        index: true,
        // 刷新 默认:true;
        refreshBtn: true,
        // 添加 默认:true;
        addBtn: false,
        // 编辑 默认:true;
        editBtn: false,
        // 删除  默认:true;
        delBtn: true,
        // 折叠筐 默认:false;
        expand: false,
        column: [
          {
            prop: "theater_name",
            label: "剧院名称",
            hide: true
          },

          {
            prop: "show_name",
            label: "节目名称",
            hide: true
          },
          {
            prop: "number",
            label: "数量",
            hide: true
          },
          {
            layout: 12,
            prop: "status",
            label: "状态",
            type: "radio",
            show: "tag",
            default: 0,
            tagtype: [
              {
                text: "可用",
                type: "success",
                value: 0
              },
              {
                text: "已过期",
                type: "danger",
                value: 1
              }
            ],
            hide: true
          },

          {
            prop: "plan_time",
            label: "游玩日期",
            type: "input",
            hide: true
          },
          {
            prop: "play_date",
            label: "演出时间",
            type: "input",
            hide: true
          }
        ],
        btnNavLeft: [
          {
            text: "添加",
            size: "mini",
            type: "success",
            click: () => {
              this.formData = {};
              this.submitType = 1;
              this.dialogFormVisible = true;
            }
          },
          {
            text: "同步计划",
            size: "mini",
            type: "primary",
            click: () => {
              ticket.syncPlan.r({ ticket_id: this.id }).then(res => {
                console.log(res);
              });
            }
          }
        ],
        btnList: [
          {
            name: "编辑",
            size: "mini",
            type: "text",
            click: (id, row, index) => {
              this.formData = row;
              this.submitType = 2;
              this.dialogFormVisible = true;
            }
          }
        ]
      },
      tableData: [],
      titleText: this.$route.query.ticket_title,
      id: this.$route.query.ticket_id,
      ticketInfo: {},
      scenicInfo: {}
    };
  },
  created() {
    this.getlist();
    this.getTicketInfo();
    this.getScenicInfo();
    // session_code
  },
  methods: {
    getScenicInfo() {
      scenic.getScenicInfo.r({ id: this.$route.query.scenic_id }).then(res => {
        this.scenicInfo = res;
      });
    },
    getTicketInfo() {
      ticket.getTicketInfo.r({ id: this.id }).then(res => {
        this.ticketInfo = res;
        console.log(this.formDesc, this.ticketInfo);
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    handleSubmit(form) {
      // let data = {
      //   ticket_id: this.$route.query.ticket_id,
      //   area_code: this.ticketInfo.area_code,
      //   area_name: this.ticketInfo.title,
      //   ticket_name: this.ticketInfo.ticket_name,
      //   ticket_code: this.ticketInfo.ticket_code
      // };
      let postData = {
        ...form,
        ticket_id: this.$route.query.ticket_id,
        area_code: this.ticketInfo.area_code,
        area_name: this.ticketInfo.title,
        ticket_name: this.ticketInfo.ticket_name,
        ticket_code: this.ticketInfo.ticket_code,
        session_code: this.ticketInfo.session_code,
        theater_code: this.scenicInfo.theater_code
      };
      if (this.submitType === 1) {
        plan.addTicketPlan.r(postData).then(res => {
          this.$message.success("创建成功");
          this.getlist();
          this.formData = {};
        });
      } else if (this.submitType === 2) {
        plan.editTicketPlan.r(postData).then(res => {
          this.$message.success("修改成功");
          this.formData = {};
          this.getlist();
        });
      }
    },
    handleSuccess() {
      this.formData = {};
      this.dialogFormVisible = false;
    },
    // 删除
    delBtn(form) {
      // plan.deleteScenic.r({ ticket_id: form.ticket_id }).then(res => {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          plan.deleteTicketPlan
            .r({ ticket_plan_id: form.ticket_plan_id })
            .then(res => {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.getlist();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //   多选
    handleSelectionChange(e) {},
    // 筛选条件
    searchSubmit(e) {
      this.searchData = e;
      if (e) {
        this.page.currentPage = 1;
      }
      this.getlist();
    },
    // 刷新
    refreshBtn(e) {
      this.getlist();
    },
    // 分页器
    refreshChange(e) {
      let that = this;
      setTimeout(() => {
        this.getlist();
      }, 1000);
    },
    getlist(e) {
      let param;
      let that = this;
      if (e) {
        that.page = e;
        param = {
          page: e.currentPage,
          limit: e.pageSize
        };
      } else {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize
        };
      }
      if (this.searchData) {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize,
          ...this.searchData
        };
      }
      param["ticket_id"] = this.id;
      plan.getTicketPlan.r(param).then(res => {
        that.tableData = res.list;
        that.page.total = res.total;
      });
    }
  }
};
</script>
